import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { styled } from "@mui/material/styles";

const StyledLoadingButton = styled(LoadingButton)<LoadingButtonProps>(
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  ({ theme }) => ({
    height: "40px",
    textTransform: "none",
    "&.Mui-disabled": {
      color: theme.palette.otherBackgroundLight.main,
    },

    "&.MuiButton-outlined": {
      "&.MuiLoadingButton-loading": {
        opacity: 1,
        backgroundColor: theme.palette.action.disabledBackground,
      },
      "& .MuiLoadingButton-loadingIndicator": {
        opacity: 1,
        color: theme.palette.primary.main,
      },
      "&.MuiLoadingButton-loading .MuiButton-label": {
        opacity: 1,
      },
    },

    "&.Mui-disabled-custom": {
      opacity: 0.5,
      cursor: "not-allowed",
      pointerEvents: "none",
    },
  })
);

export default StyledLoadingButton;
